import React, { useRef, useState } from "react";
import { cx, useTranslations, useLineClamp } from "@jugl-web/utils";
import { parseChatMarkdown } from "@jugl-web/domain-resources/chat-bot/utils/parseChatMarkdown";
import { useChatMessageBubble } from "../../providers/ChatMessageBubbleProvider/useChatMessageBubble";
import { ChatMessageMember } from "../ChatMessageMember";

export const ChatMessageBody: React.FC<{
  body: string;
  isOutgoing: boolean;
  searchQuery?: string;
  isEmojiOnly?: boolean;
  isFailed?: boolean;
}> = ({ body, isOutgoing, searchQuery, isEmojiOnly, isFailed }) => {
  const [isReadingMore, setIsReadingMore] = useState(false);
  const { t } = useTranslations();
  const clampRef = useRef<HTMLParagraphElement | null>(null);
  const isClamped = useLineClamp(clampRef, body);
  const { onAvatarClick } = useChatMessageBubble();

  return (
    <span
      className={cx("font-secondary text-sm leading-[18px] text-dark", {
        "text-white": isOutgoing,
        "text-[32px]": isEmojiOnly,
        "bg-white text-tertiary-800": isFailed,
      })}
    >
      <>
        <span ref={clampRef} className={cx(!isReadingMore && "line-clamp-[8]")}>
          {parseChatMarkdown({
            raws: body,
            whiteLinks: isOutgoing,
            searchQuery,
            onMentionClick: onAvatarClick,
            mentionMemberRenderer: ({ userId, username }) => (
              <ChatMessageMember
                text={username}
                userId={userId}
                onClick={onAvatarClick}
              />
            ),
          })}
        </span>
        {isClamped && (
          <>
            {" "}
            <span
              className={cx(
                "cursor-pointer text-sm leading-[18px] font-bold",
                isOutgoing
                  ? "rounded bg-[#0F72C2] px-1 text-white"
                  : "text-primary-500",
                isFailed && "bg-white text-tertiary-800"
              )}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                setIsReadingMore((prev) => !prev);
              }}
            >
              {isReadingMore
                ? t({
                    id: "common.read-less",
                    defaultMessage: "Read Less",
                  })
                : t({
                    id: "common.read-more",
                    defaultMessage: "Read More",
                  })}
            </span>
          </>
        )}
      </>
    </span>
  );
};
